// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.4.2';
export const APP_NAME = 'tim-app';
export const FILE_HASH = '1770198056406';
export const BUILD_DATE = '2026-02-04T09:40:56.406Z';
/* tslint:enable */
